
/**
 * 조회할 강의의 타입을 지정합니다.
- `USER`: 특정 사용자의 강의
- `ENROLLED`: 특정 사용자가 수강 신청한 강의 (수강생 입장)
- `POPULAR`: 인기 강의
- `ROADMAP`: 로드맵 강의
- `FORYOU`: 추천 강의
- `MY_PUBLISHED`: 현재 로그인한 사용자가 게시한 강의 (게시된 강의만, 강사 입장)

 */
export type GetCoursesType = typeof GetCoursesType[keyof typeof GetCoursesType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCoursesType = {
  USER: 'USER',
  ENROLLED: 'ENROLLED',
  POPULAR: 'POPULAR',
  ROADMAP: 'ROADMAP',
  FORYOU: 'FORYOU',
  MY_PUBLISHED: 'MY_PUBLISHED',
} as const;
